import { ReactNodeViewRenderer as g } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { IMAGE_MOBILE_FULL_WIDTH_STYLES as u } from "../../constants/default-styles.mjs";
import { ImageNameEnum as I, ImageModeEnum as L } from "./image-enum.mjs";
import { convertStyleObjectToCss as l } from "../../utils/style-helpers.mjs";
import { CustomImage as d } from "./custom-image.mjs";
import { Image as A } from "./image.mjs";
import { getContainerWidthFromElement as M } from "./utils/get-container-width-from-element.mjs";
import { getImageAttrs as T } from "./utils/get-image-attrs.mjs";
import { getImageWithLinkHtml as _ } from "./utils/get-image-with-link-html.mjs";
import { MOBILE_FULL_WIDTH_CLASSNAME as a } from "./constants/index.mjs";
import { mergeAttributes as H } from "../../node_modules/@tiptap/core/dist/index.mjs";
const $ = A.configure({ inline: !0 }).extend({
  name: I.Inline,
  inline: !0,
  addNodeView() {
    return g(d);
  },
  parseHTML() {
    return [
      {
        tag: "img",
        getAttrs: (t) => {
          const e = t.closest("a"), n = e == null ? void 0 : e.getAttribute("href"), r = T(t), o = M(t), s = !!t.closest(`span.${a}`);
          return {
            imageMode: L.Inline,
            ...r,
            href: n,
            containerWidth: o,
            isMobileFullWidth: s
          };
        }
      }
    ];
  },
  renderHTML({
    HTMLAttributes: { href: t, alt: e, title: n, width: r, height: o, containerWidth: s, src: c, isMobileFullWidth: p }
  }) {
    const i = {};
    r && o && (i.aspectRatio = `${r}/${o}`), s !== "auto" && (i.width = s);
    const f = H({
      src: c,
      alt: e,
      title: n,
      width: r,
      style: l(i)
    }), m = _(f, { href: t });
    return p ? [
      "span",
      {
        class: a
      },
      ["head", {}, ["style", { type: "text/css" }, u]],
      m
    ] : m;
  }
});
export {
  $ as InlineImage
};
